import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import { setAccountsDetails } from "../../Redux/AccountSlice";
import AccountService from "../../Services/http/AccountService";

export const getAccountDetailsList = async (dispatch) => {
  dispatch(setIsActiveSpinner(true));
  const response = await AccountService.getAccountDetailsList();
  dispatch(setIsActiveSpinner(false));
  if (response && response["message"] === "success") {
    dispatch(setAccountsDetails(response["items"]));
  }
};


